import { render } from "./Users.vue?vue&type=template&id=eb2e8344&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=eb2e8344&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-eb2e8344"

export default script